import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem('sap_bim_user');
    return saved ? JSON.parse(saved) : null;
  });
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('sap_bim_token');
    if (!token) {
      setIsReady(true);
      return;
    }
    // Confirm the saved token still works before trusting it
    api.get('/v1/auth/me')
      .then((res) => {
        setUser(res.data);
        localStorage.setItem('sap_bim_user', JSON.stringify(res.data));
      })
      .catch(() => {
        localStorage.removeItem('sap_bim_token');
        localStorage.removeItem('sap_bim_user');
        setUser(null);
      })
      .finally(() => setIsReady(true));
  }, []);

  useEffect(() => {
    const onUnauthorized = () => setUser(null);
    window.addEventListener('sap-bim-unauthorized', onUnauthorized);
    return () => window.removeEventListener('sap-bim-unauthorized', onUnauthorized);
  }, []);

  const login = useCallback(async (username, password) => {
    const form = new URLSearchParams();
    form.append('username', username);
    form.append('password', password);
    const res = await api.post('/v1/auth/login', form, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
    localStorage.setItem('sap_bim_token', res.data.access_token);
    localStorage.setItem('sap_bim_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('sap_bim_token');
    localStorage.removeItem('sap_bim_user');
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, isReady, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
}
